import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError } from "../../../../interfaces/base";
import {
  IFetchUserTrainingProgramsPayload,
  IFetchUserTrainingProgramsState,
} from "../../../../interfaces/store/user-interfaces";

const initialState: IFetchUserTrainingProgramsState = {
  trainingPrograms: [],
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
  metadata: {
    total: 0,
    page: 0,
  },
};

const _fetchUserTrainingProgramsStart = (
  state: IFetchUserTrainingProgramsState,
  { payload }: PayloadAction<IFetchUserTrainingProgramsPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _fetchUserTrainingProgramsSuccess = (
  state: IFetchUserTrainingProgramsState,
  { payload }: PayloadAction<any>
) => {
  state.trainingPrograms = payload.data.data;
  state.metadata = payload.data.metadata;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _fetchUserTrainingProgramsFailed = (
  state: IFetchUserTrainingProgramsState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetUserTrainingPrograms = (state: IFetchUserTrainingProgramsState) => {
  return { ...initialState };
};

const UserTrainingProgramsSlice = createSlice({
  name: "userTrainingPrograms",
  initialState,
  reducers: {
    fetchUserTrainingProgramsStart: _fetchUserTrainingProgramsStart,
    fetchUserTrainingProgramsSuccess: _fetchUserTrainingProgramsSuccess,
    fetchUserTrainingProgramsFailed: _fetchUserTrainingProgramsFailed,
    resetUserTrainingPrograms: _resetUserTrainingPrograms,
  },
});

export const {
  fetchUserTrainingProgramsStart,
  fetchUserTrainingProgramsSuccess,
  fetchUserTrainingProgramsFailed,
  resetUserTrainingPrograms,
} = UserTrainingProgramsSlice.actions;
export default UserTrainingProgramsSlice.reducer;
